import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    my: '4px',
    padding: 0,
  },
  avatarContainer: {
    width: '100%',
  },
  modalMargin: {
    marginBottom: '30px',
  },
  footerLabel: { fontSize: 12, fontStyle: 'italic' },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
